export const createInvoiceItem = `
    mutation createInvoiceItem($input: CreateInvoiceItemInput!) {
        createInvoiceItem(input:$input) {
            id
            customerId
            amount
            currency
            description
            period {
                start
                end
            }
            price
            invoice
            quantity
            subscription
            unitAmount
        }
}`;

export const updateInvoiceItem = `
    mutation updateInvoiceItem($input: UpdateInvoiceItemInput!) {
        updateInvoiceItem(input:$input){
            id
            customerId
            amount
            currency
            description
            period {
                start
                end
            }
            price
            invoice
            quantity
            subscription
            unitAmount
        }
}`;

export const deleteInvoiceItem = `
    mutation deleteInvoiceItem($input: DeleteInvoiceItemInput!) {
        deleteInvoiceItem(input:$input) 
}`;
